/**
 * The portal's one time formatter for shell and module status lines.
 *
 * Every clock time a reader compares on one page (the shell's "Data to …"
 * line, a module's "Data rebuilt at …" line) goes through here, so the same
 * instant always reads as the same clock time. Times are pinned to UTC and say
 * so ("12:00 UTC"): a browser-local time would drift an hour from the shell
 * line every British Summer Time (owner ruling, bug 40e0402f).
 */

const TIME = new Intl.DateTimeFormat("en-GB", {
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
  timeZone: "UTC",
});

function parse(value: string | number | Date | null | undefined): Date | null {
  if (value === null || value === undefined || value === "") return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** "12:00 UTC"; "" for a missing or unparseable value. */
export function formatUtcTime(value: string | number | Date | null | undefined): string {
  const date = parse(value);
  return date ? `${TIME.format(date)} UTC` : "";
}

/** "2026-06-01 12:00 UTC"; "" for a missing or unparseable value. */
export function formatUtcStamp(value: string | number | Date | null | undefined): string {
  const date = parse(value);
  return date ? `${date.toISOString().slice(0, 10)} ${formatUtcTime(date)}` : "";
}
